var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"input-box"},[_c('img',{staticClass:"qr-img",attrs:{"src":require("../../../public/assets/images/RPA_testing_qr.png")}}),_c('div',{staticStyle:{"margin":"0 auto","font-size":"large"}},[_c('a',{attrs:{"target":"_blank","href":"https://www.v2.elconnect.sg/rpa-testing1"}},[_vm._v("Click here if you can't scan")])])])])
}]

export { render, staticRenderFns }